import { Injectable } from '@angular/core'
import { CanActivate } from '@angular/router'
import { StepService } from 'app/shared/steps/step.service'

@Injectable()
export class FlowGuard implements CanActivate {

    constructor(private stepService: StepService) {}

    canActivate(): boolean {
        const isFLowActivated = this.stepService.isFlowActivated()
        if (!isFLowActivated) { window.location.href = '/' }
        return isFLowActivated
    }
}
